/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable indent */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser'
import axios from 'axios'
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENT_ID!,
    authority: process.env.REACT_APP_SSO_AUTHORITY!,
    redirectUri: '/blank.html'
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to 'true' if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii !== undefined) {
          return
        }
        switch (level) {
          case LogLevel.Error: break
          case LogLevel.Info: break
          case LogLevel.Verbose: break
          case LogLevel.Warning: break
          default:
        }
      }
    }
  }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read']
}

export const setToken = (token: any): void => {
  axios.defaults.headers.common.Authorization = 'Bearer ' + token
}
